<template>
  <div class="entity project">
    <EntityInput v-model="entity.name" fieldName="name" ref="name" :loading="checkingName" :externalError="nameError" v-if="visibleFields.name" />
  </div>
</template>

<script>
  import debounce from 'lodash/debounce'
  import EntityInput from '@/components/forms/EntityInput'
  import FormEntity from '@/mixins/FormEntity'
  import api from '@/api'

  export default {
    name: 'FormProject',
    mixins: [
      FormEntity,
    ],
    components: {
      EntityInput,
    },
    data() {
      return {
        object: 'Project',
        commonFields: ['name'],
        nameError: null,
        checkingName: false,
      }
    },
    watch: {
      'entity.name'(newName) {
        this.nameError = null
        if (newName && this.mode === 'creating') {
          this.checkingName = true
          this.debouncedCheckName(newName)
        }
      },
    },
    methods: {
      debouncedCheckName: debounce(function checkName(newName) {
        api.checkProjectName(newName).catch(error => {
          this.nameError = error
        }).finally(() => {
          this.checkingName = false
        })
      }, 500, {leading: false})
    },
  }
</script>
